export default "__VITE_ASSET__BycCsYS8__"